var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("dialogue", {
        attrs: {
          title: "Delete",
          paragraph:
            "Are you sure you want to delete Invoice " + _vm.term + "?",
          button_names: ["Full Delete", "Quickbooks Delete"],
          show: _vm.delete_dialogue
        },
        on: { dialogue: _vm.deleteInvoice, cancel: _vm.cancelDelete }
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "scroll",
            staticStyle: {
              width: "65%",
              height: "calc(100vh - 75px)",
              float: "left"
            }
          },
          [
            _c("layout-3", {
              staticStyle: { "max-height": "30vh" },
              attrs: { id: _vm.pageid1, term: _vm.term, width: 4, height: 1 }
            }),
            _vm._v(" "),
            _vm.perms.includes("1")
              ? _c("layout-1", {
                  attrs: {
                    table_name: "Job Orders",
                    id: _vm.pageid2,
                    searchbar: false,
                    collapseable: true,
                    height_limit: false,
                    navbar: false,
                    select_reroute: true,
                    button_perm: "2",
                    button_name: "Select",
                    term: _vm.term
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.perms.includes("6")
              ? _c("layout-1", {
                  attrs: {
                    table_name: "Job Schedules",
                    id: _vm.pageid3,
                    searchbar: false,
                    collapseable: true,
                    height_limit: false,
                    navbar: false,
                    select_reroute: true,
                    button_perm: "8",
                    button_name: "Select",
                    term: _vm.term
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.perms.includes("7")
              ? _c("layout-1", {
                  attrs: {
                    table_name: "Documents",
                    id: _vm.pageid4,
                    searchbar: false,
                    collapseable: true,
                    height_limit: false,
                    navbar: false,
                    select_reroute: true,
                    button_perm: "7",
                    button_name: "Select",
                    term: _vm.term
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.perms.includes("8")
              ? _c("layout-1", {
                  attrs: {
                    table_name: "TSheets",
                    id: _vm.pageid5,
                    searchbar: false,
                    collapseable: true,
                    height_limit: false,
                    navbar: false,
                    term: _vm.term
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.perms.includes("36")
              ? _c("layout-1", {
                  attrs: {
                    table_name: "Activities",
                    id: _vm.pageid6,
                    searchbar: false,
                    collapseable: true,
                    height_limit: false,
                    navbar: false,
                    term: _vm.term
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scroll",
            staticStyle: {
              width: "30%",
              height: "calc(100vh - 75px)",
              float: "right"
            }
          },
          [
            _c("invoice", {
              ref: "doc",
              staticStyle: { width: "100%", height: "calc(95%)" },
              attrs: {
                dir: "Invoice_" + parseInt(_vm.term) + ".pdf",
                id: parseInt(_vm.term),
                invoice_id: _vm.term
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("43")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit")
                    }
                  }
                },
                [_vm._v("Edit Invoice")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("81")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.deleteInvoiceDialogue()
                    }
                  }
                },
                [_vm._v("Delete Invoice")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f826734", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f826734","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Invoices.vue
// module id = 547
// module chunks = 0